<template>
  <b-card class="address-item" :id="'item-' + address.id" v-if="address.id">
    <b-row>
      <h4 class="col-12 align-self-center">{{address.reference}}</h4>
      <div class="col-7 align-self-center">{{address.place.formatted_address}}</div>
      <div class="col-2 align-self-center">{{address.address_extra}}</div>
      <div class="col-3 text-right align-self-center" v-if="address.id !== this.user.profile_address_id">
        <b-button router-tag="a" variant="default" @click="setFavorite(address)" v-if="address.favourite === 0">
          <font-awesome-icon class="text-secondary " :icon="['far', 'bookmark']" size="lg" />
        </b-button>
        <b-button router-tag="a" variant="default" @click="setUnfavorite(address)" v-if="address.favourite !== 0">
          <font-awesome-icon class="text-secondary" icon="bookmark" size="lg" />
        </b-button>
        <b-button router-tag="a" variant="default" v-b-modal="'confirmDelete-' + address.id">
          <font-awesome-icon class="text-danger" icon="trash-alt" size="lg" />
        </b-button>
      </div>
      <div class="col-3 text-right" v-if="address.id === this.user.profile_address_id">
        <b-button variant="default" @click="setAsDefault(address.id)" disabled>
          <font-awesome-icon class="text-secondary " :icon="['far', 'bookmark']" size="lg" />
        </b-button>
        <b-button variant="default" v-b-modal="'confirmDelete-' + address.id" disabled>
          <font-awesome-icon class="text-danger" icon="trash-alt" size="lg" />
        </b-button>
      </div>
    </b-row>
    <b-modal ok-variant="danger" :id="'confirmDelete-' + address.id" :ref="'confirmDelete-' + address.id" @ok="confirmDelete(address.id)">
      <div slot="modal-title" v-translate>Alert</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <p v-translate="{reference: address.reference}">Are you sure you want to delete the address with reference "%{reference}"?</p>
        <div slot="modal-ok" v-translate>Confirm delete!</div>
        <div slot="modal-cancel" v-translate>Cancel</div>
    </b-modal>
  </b-card>
</template>
<script>
import { ADDRESS_DELETE, ADDRESS_UPDATE } from '@/store/actions.type'

export default {
  name: 'AddressListItem',
  data() {
    return {
      user: null
    }
  },
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  created() {
    this.user = this.$store.state.auth.profile
  },
  methods: {
    confirmDelete(id) {
      this.$store.dispatch(ADDRESS_DELETE, id).then(response => {
        this.$parent.fetchAddresses()
      })
    },
    setFavorite(item) {
      this.$store.dispatch(ADDRESS_UPDATE, [item.id, { favourite: true }]).then(response => {
        this.address.favourite = 1
      })
    },
    setUnfavorite(item) {
      this.$store.dispatch(ADDRESS_UPDATE, [item.id, { favourite: false }]).then(response => {
        this.address.favourite = 0
      })
    }
  }
}

</script>
